import { PubSubService } from './../service/pubSub.service';
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { dashboardService } from '../services/dashboard/dashboard.service';
import { homedashService } from '../services/homeDash/homedash.service';
import {BHttp} from '../service/bHTTP';
/**
* Model import Example : 
* import { HERO } from '../models/hero.model.ts';
*/

@Component({
    selector: 'bh-homepage',
    templateUrl: './homepage.template.html'
})

export class homepageComponent  implements OnInit, OnDestroy {

  getDataSub;
  dashboardSelectedObject;
  homeDashData;
  showSSSmiley;
  chartsData = {};
  products = [];
  categories = [];
  ssdata;
  icc = true;
  wic = true;
  ss = true;
  wicData;
  // chartsData = { "byCategory": { "datasets": [{ "label": "Watch", "data": [{ "x": 942, "y": 142.16699999999963, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "Service", "data": [{ "x": 831, "y": 831.3399999999972, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "Close", "data": [{ "x": 751, "y": -666.4730000000011, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "Reconnect", "data": [{ "x": 599, "y": -5.713000000000001, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "Pay", "data": [{ "x": 405, "y": -160.53700000000038, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "Hardware", "data": [{ "x": 264, "y": -214.54099999999931, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "Agreements", "data": [{ "x": 88, "y": -10.410999999999941, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "Install", "data": [{ "x": 39, "y": 47.888000000000005, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "Activate", "data": [{ "x": 35, "y": 95.42399999999998, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "Disconnect", "data": [{ "x": 30, "y": -38.12500000000004, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }], "yMax": 831.3399999999972, "yMin": -666.4730000000011 }, "byProduct": { "datasets": [{ "label": "SuperSport", "data": [{ "x": 1057, "y": 95.11399999999814, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "M-net", "data": [{ "x": 991, "y": -424.83299999999616, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "DStv Premium", "data": [{ "x": 62, "y": -192.01399999999984, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "DStv Compact", "data": [{ "x": 31, "y": 9.341000000000012, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "DStv Extra", "data": [{ "x": 21, "y": 67.96199999999999, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "BoxOffice", "data": [{ "x": 12, "y": -26.692, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "DStv Access", "data": [{ "x": 8, "y": -20.009999999999998, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "DStv Mobile", "data": [{ "x": 7, "y": -13.389000000000003, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }, { "label": "DStv Family", "data": [{ "x": 1, "y": 0.9050000000000002, "r": 5 }], "backgroundColor": "rgb(0, 0, 0)" }], "yMax": 95.11399999999814, "yMin": -424.83299999999616 } };
  constructor(private r: ActivatedRoute, private mulNotificationService: dashboardService,
    private pubsub: PubSubService, private dashDisplayData: homedashService, private bhttp:BHttp) { }

  ngOnInit() {
    this.getHomeDashboardData();
    this.getDataSub = this.pubsub.$sub('getData', (eventObject) => {
      this.getHomeDashboardData();
    });
    this.dashboardSelectedObject = this.mulNotificationService.dashboardObject;
    // for clearing unwanted tab icons
    this.pubsub.$pub('tabListner', []);

  }

  getHomeDashboardData() {
    this.dashDisplayData.getHomeData().then(result => {
      this.homeDashData = result;
      if (result && result.hasOwnProperty('social')) {
        this.ssdata = result['social'];
        if (this.ssdata.hasOwnProperty('byProduct') && Object.keys(this.ssdata['byProduct']).length > 0) {
          this.products = this.ssdata['byProduct']['datasets'];
        } else {
          this.products = [];
        }
        if (this.ssdata.hasOwnProperty('byCategory') && Object.keys(this.ssdata['byCategory']).length > 0) {
          this.categories = this.ssdata['byCategory']['datasets'];
        } else {
          this.categories = [];
        }
      }

      if (result && result.hasOwnProperty('wic')) {
          this.wicData = result['wic'];
      }
    }, error => {
      console.log(error);
    })
  }

  ngOnDestroy() {
    this.getDataSub.unsubscribe();
  }

}


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/homepageComponent/homepage.component.ts